// extracted by mini-css-extract-plugin
export default {"root":"styles_root__DUyfh","wrapper":"styles_wrapper__g+qt3","menuItems":"styles_menuItems__6nOPY","container":"styles_container__SjgoK"};